import { useEffect, useState } from 'react';


import { useQuery } from '@apollo/client/react';

import { GqlProvince, MdCountryEnum } from '@anyx/common-graphql';
import { AnyXLanguage } from '@anyx/shared-utils';

import { PROVINCES } from '../graphql';

interface UseProvinceOptions {
  useRegionId?: boolean;
  country?: MdCountryEnum | string;
  language?: AnyXLanguage;
}

type ProvinceOption = {
  label: string;
  value: string;
};

export const useProvinceOptions = ({
  useRegionId,
  country,
  language = AnyXLanguage.EN_US,
}: UseProvinceOptions = {}): { provinceOptions: ProvinceOption[] } => {
  const [provinceOptions, setProvinceOptions] = useState<ProvinceOption[]>([]);

  const { data } = useQuery(PROVINCES, {
    skip: !country,
    variables: {
      filter: {
        countryId: country,
      },
    },
  });

  useEffect(() => {
    if (data?.MdProvinces) {
      setProvinceOptions(
        data.MdProvinces.map(({ name, lname, id, country }) => {
          const provinceName = GqlProvince.localizeProvince({ country, lname, name }, language);
          return {
            label: provinceName,
            value: useRegionId ? id : provinceName,
          };
        })
      );
    }
  }, [data, language, useRegionId]);

  return { provinceOptions };
};
